import { tsValidateValue } from '@nu-art/ts-common';
import { smartDocParamType_Static } from './types.js';
export const Validator_SmartDocStaticParamType = tsValidateValue([smartDocParamType_Static]);
//# sourceMappingURL=validator.js.map